export const removeAllQueryParams = (url: string) => {
  const parsedUrl = new URL(url);

  parsedUrl.search = '';

  return parsedUrl.toString();
};

export const removeQueryParams = (url: string, paramsToRemove: string[]) => {
  const parsedUrl = new URL(url);
  const searchParams = parsedUrl.searchParams;

  paramsToRemove.forEach((param) => {
    searchParams.delete(param);
  });

  parsedUrl.search = searchParams.toString();

  return parsedUrl.toString();
};
